import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="page-footer d-none">
    <h3 className="mb-0">Page footer</h3>
  </footer>
  );
};

export default Footer;
